import NoQuizzes from 'components/Quizzes/NoQuizzes';
import QuizCard from 'components/Quizzes/QuizCard';
import { PageContext } from 'pages/Quizzes/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Text } from 'shell/components';

const QuizList = () => {
    const { quizzes, hasQuizzes, canManageQuizzes, onClick, onClickEdit, onClickDelete } = useContext(PageContext);
    const { t } = useTranslation('quiz');

    if (!hasQuizzes) return <NoQuizzes />;
    if (!quizzes.length) {
        return (
            <Text align={'center'} color={'light'} role={'status'} sx={{ py: 10 }}>
                {t('no-results', 'No quizzes match your search.')}
            </Text>
        );
    }

    return (
        <Stack spacing={4}>
            {quizzes.map((quiz) => (
                <QuizCard
                    key={quiz.id}
                    quiz={quiz}
                    disableOptions={!canManageQuizzes}
                    onClick={onClick}
                    onClickEdit={onClickEdit}
                    onClickDelete={onClickDelete}
                />
            ))}
        </Stack>
    );
};

export default QuizList;
